module.exports = __webpack_public_path__ + "img/global-2014-klaus-beck.4c2cdbed.jpg";